currentLang = currentLang_short; 

$( document ).ready(function() {

  var checkedval = $('.input-type-radio:checked').val();
  $('#delivery-method').val(checkedval);
  $('.input-type-radio').on('change', function() {
     var checkedval = $('.input-type-radio:checked').val();
      $('#delivery-method').val(checkedval);
  });
  
  $('.thumbnail-slider .slick-thumbnail-slider').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: false,
    focusOnSelect: true,
    arrows: true,
    // verticalSwiping:true,
    // vertical:true,
    prevArrow:'<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Nach links schieben" aria-controls="GalleryThumbnails-template--15165952688221__main" data-step="3"><svg xmlns="http://www.w3.org/2000/svg" width="11.067" height="22.134" viewBox="0 0 11.067 22.134" class="icon icon-caret"><path id="Icon_ionic-md-arrow-dropdown" data-name="Icon ionic-md-arrow-dropdown" d="M0,0,11.067,11.067,22.134,0Z" transform="translate(11.067) rotate(90)" fill="#currentColor"></path></svg></button>',
    nextArrow:'<button type="button" class="slider-button slider-button--next" name="next" aria-label="Nach rechts schieben" aria-controls="GalleryThumbnails-template--15165952688221__main" data-step="3"><svg xmlns="http://www.w3.org/2000/svg" width="11.067" height="22.134" viewBox="0 0 11.067 22.134" class="icon icon-caret"><path id="Icon_ionic-md-arrow-dropdown" data-name="Icon ionic-md-arrow-dropdown" d="M0,0,11.067,11.067,22.134,0Z" transform="translate(11.067) rotate(90)" fill="#currentColor"></path></svg></button>',
    infinite: false,
    responsive: [
        {
            breakpoint: 750,
            settings: "unslick"
        }
    ]
  });

  // cross selling product slider
   $(".cross-selling-wrapper.cross-selling-slider").slick({
    slidesToShow: 3,
    slidesToScroll:3,
    dots: true,
    infinite: false,
     centerMode: false,
    arrows: false,
     variableWidth: true,
     responsive: [
       {
            breakpoint:1800,
              settings: {
              slidesToShow: 2,
              slidesToScroll:2,
          },           
        },
        {
            breakpoint:1280,
              settings: {
              slidesToShow: 1,
              slidesToScroll:1,
          },           
        },
        {
            breakpoint:993,
              settings: {
              slidesToShow: 3,
              slidesToScroll:3,
          },           
        },
         {
            breakpoint:800,
              settings: {
              slidesToShow: 2,
              slidesToScroll:2,
          },           
        },
        {
            breakpoint:640,
              settings: {
              slidesToShow: 1,
              slidesToScroll:1,
          },           
        }
    ]
  })
  
  
  // cross selling popup
  $(document).on('click', '.card-wrapper .card .card-atc button.card-atc-btn.cart-open-popup', function(){
    $(this).siblings('.card-product-popup-wrapper').fadeIn();
    $('body').addClass('card-product-popup-open');
  })
  $(document).on('click', '.card-product-popup .card-popup-product-form .card-popup-close button', function(){
    $('.card-wrapper .card .card-product-popup-wrapper').fadeOut();
    $('body').removeClass('card-product-popup-open');
  })

  // card-product radio change event
  $(document).on('change', '.card-product-radio .input-type-radio', function(){
    const allVariants = JSON.parse($(this).parents('fieldset').siblings('[type="application/json"]').text() || "[]")
    const fieldsets = Array.from($(this).parents('fieldset'));
    const options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    const currentVariant = allVariants.find((variant) => {
      return !variant.options.map((option, index) => {
        return options[index] === option;
      }).includes(false);
    });
    currentVariant.id && $(this).parents(".card-popup-info").find('product-form [name="id"]').val(currentVariant.id)
  })

  
// feature image slider buttons
  function disabledSlideArrowThumbnail(){
    const prevSlideThumbnail = $('.thumbnail[aria-current]').parents('li').is(':first-child');
    const nextSlideThumbnail = $('.thumbnail[aria-current]').parents('li').is(':last-child');
    if(prevSlideThumbnail){
      $('slider-component .feature-slider-arrows .slider-button--prev').addClass('disabled').attr('disabled', true)   
    } else {
      $('slider-component .feature-slider-arrows .slider-button--prev').removeClass('disabled').removeAttr('disabled')   
    }
    if(nextSlideThumbnail){
      $('slider-component .feature-slider-arrows .slider-button--next').addClass('disabled').attr('disabled', true)   
    } else {
      $('slider-component .feature-slider-arrows .slider-button--next').removeClass('disabled').removeAttr('disabled')   
    }
  }
  disabledSlideArrowThumbnail();
  $(document).on('click', '.thumbnail-slider .slider__slide', function(){
    disabledSlideArrowThumbnail()
  })
  $(document).on('click', 'slider-component .feature-slider-arrows .slider-button--prev', function(){
    const prevSlide = $('.thumbnail[aria-current]').parents('li').prev('li');
    $('slider-component .feature-slider-arrows .slider-button--next').removeClass('disabled').removeAttr('disabled')
    if(prevSlide.length) {
      prevSlide.find('button').trigger('click')
    } 
    disabledSlideArrowThumbnail()
    // if(prevSlide.is(':first-child')){
    //   $(this).addClass('disabled').attr('disabled', true)   
    // } else {
    //   $(this).removeClass('disabled').removeAttr('disabled')   
    // }
  })
  $(document).on('click', 'slider-component .feature-slider-arrows .slider-button--next', function(){
    const nextSlide = $('.thumbnail[aria-current]').parents('li').next('li');
    
    $('slider-component .feature-slider-arrows .slider-button--prev').removeClass('disabled').removeAttr('disabled')
     
    if(nextSlide.length) {
      nextSlide.find('button').trigger('click')
    }
    disabledSlideArrowThumbnail()
    // if(nextSlide.is(':last-child')){
    //   $(this).addClass('disabled').attr('disabled', true)   
    // } else {
    //   $(this).removeClass('disabled').removeAttr('disabled')   
    // }
  });

  $(document).on('click','.product-form__input .swatch', function(){
    $('.thumbnail-slider .slick-thumbnail-slider').slick('slickGoTo',0 );
  })
     
  /*setTimeout(function(){
  var filterLength = $('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option').length;
    
    if(filterLength < 1){
      $('.facets__wrapper').addClass('hidden');
    }
  },1500);*/

  $(document).on('click','a.profile', function(){
    var link = $(this).attr('href');
    
    if(link == ''){
      event.preventDefault();
    }
    // return false;
  });
  
  $('ul.header__submenu').each(function(){
  	let len = $(this).children('li').length;
    
    if(len >= 10){
    	$(this).addClass('column-2');
    }
  });
  
  
  $('.megaLinkContainer').each(function (){
    var countMenuli = $(this).children('.megaLinkBox');
    if(countMenuli.length > 8){
      $(this).addClass('column3');
    }
  });
  
  $(document).on('click','.list-menu li .list-menu__item[aria-expanded]',function(){
    var $this =  $(this);
	$this.parent('details').parent('li').siblings('li').find("details").removeAttr('open');
  });
  
  $('summary.header__menu-item, ul.header__submenu, ul.header__subsubmenu').hover(function(){
//     $('summary.header__menu-item').parent('details').removeAttr('open');
    // $('summary.header__submenu-item').parent('details').removeAttr('open');
    $(this).parent('details').attr('open','open');
  });
  
  $(document).on('click','summary.header__menu-item',function(){
  	let $this = $(this);
    let link = $this.data('link');
    
    window.location.href=link;
  });
  
  /*$('ul.header__subsubmenu').hover(function(){
    $('summary.header__submenu-item').parent('details').removeAttr('open');
    $(this).parent('details').attr('open','open');
  });*/
  
  $('summary.header__menu-item, ul.header__submenu').mouseleave(function(){
    $(this).parent('details').removeAttr('open');
  });
  
  $('#shopify-section-header-website .megaLinkContainer').each(function (){
    var countMenuli = $(this).children('.megaLinkBox');
    if(countMenuli.length > 4){
      //$(this).addClass('column2');
    }
  });
  
  $(document).on('click','#cart-icon-search',function(){
    $('.boost-pfs-search-suggestion-mobile-top-panel').show();
    $('.search__input.field__input').focus();
  });

  $('#shopify-section-header-website .is_megamenu .megaLinkBox .megaLink').hover(function(){
    // $('#shopify-section-header-website .megaLink-tab .megaLinkBox').removeClass('active');
    // $('#shopify-section-header-website .megaLink-tab .megaLink-right .megasub-content').removeClass('active');
    $(this).parents('.megaDrawer.active').find('.megaLinkBox').removeClass('active');
    $(this).parents('.megaLinkBox').addClass('active');
    $(this).parents('.megaDrawer.active').find('.megaLink-right').children('.megasub-content').removeClass('active');

    var handle = $(this).data('handle');
    $(this).parents('.megaLink-tab').find('.megaLink-right .megasub-content[data-handle="'+handle+'"]').addClass('active');
    //     console.log(handle);
  });

  $('#shopify-section-header-website .megaLinkBox .submenu-title').click(function(){
    $(this).parents('.megaLinkBox').siblings('.megaLinkBox').removeClass('active');
    $(this).parents('.megaLinkBox').toggleClass('active');
  });

  $(document).on('mouseenter','.megaDrawer',function(){
    if($(this).hasClass('is_dropdown') || $(this).hasClass('is_megamenu')){
      $('body').addClass('megamenu-open');
    }else{
      $('body').removeClass('megamenu-open');
    }    
  });
  $(document).on('mouseleave','.megaDrawerContent, .megaDrawer', function(){
    $('body').removeClass('megamenu-open');
    $('.megaDrawer').removeClass("active"); 
    $('.is_dropdown .megaLinkBox').removeClass("active"); 
  });

  $(".megaHeader .megaDrawer").hover(function(){
    $('.megaDrawer').removeClass("active"); 
    $(this).addClass("active");
  });

/* Mobile Menu */
  $(document).on('click','.menu-drawer__menu .menu-drawer__menu-item',function(){
    var $this =  $(this);
    var link = $(this).attr('aria-controls');
	$('.header__icons .mobile-back-wrap').addClass('active');
    $('.header__icons .mobile-back-wrap .icon_back').attr('data-link',link);
    $('.header__icons .hide-desktop').addClass('hidden');
  });
  
  $(".menu-drawer-container .header__icon--menu").click(function(){
    $('.header__icons .mobile-back-wrap').removeClass('active');
    $('.header__icons .mobile-back-wrap .icon_back').attr('data-link','');
    $('.header__icons .hide-desktop').removeClass('hidden');
  });

  $(".mobile-back-wrap .icon_back").click(function(){
    var link = $(this).attr('data-link');
    let count_menu = $('.menu-opening').length;    
    
    if(count_menu == 1){
      $('.header__icons .mobile-back-wrap').removeClass('active');
      $('.header__icons .mobile-back-wrap .icon_back').attr('data-link','');
      $('.header__icons .hide-desktop').removeClass('hidden');
    }
    if(count_menu == 2){
      var sublink = $('.menu-drawer__menu-item[aria-controls="'+link+'"]').parents('.menu-drawer__submenu').attr('id');
      $('.header__icons .mobile-back-wrap .icon_back').attr('data-link',sublink);
      
    }
    
    $('.menu-drawer__menu-item[aria-controls="'+link+'"]').attr('aria-expanded','false'); 
    $('.menu-drawer__menu-item[aria-controls="'+link+'"]').parent().removeClass('menu-opening').removeAttr('open');    
  });

  $(document).on('click','.mobilemenu_tabs .mobilemenu_tab',function(){  
    var tab_id = $(this).attr('data-tab');
    $(this).parent().find('.mobilemenu_tab').removeClass('active'); 
    $(this).parent().next().find('.mobilemenu_tab_content').removeClass('active');   
    $(this).addClass('active');
    $(tab_id).addClass('active');    
  });

  $(document).on('mouseenter','.fz-tooltip svg',function(){
    $('.fz-tooltiptext').addClass('fz-active');
  });
  $(document).on('mouseleave','.fz-tooltip svg',function(){
    $('.fz-tooltiptext').removeClass('fz-active');
  });


  setTimeout(() => { 
             if($('.boost-pfs-filter-option-range-slider').length > 0){
    var upper = $('.boost-pfs-filter-option-range-slider .noUi-handle-upper').attr('aria-valuenow');          
    var lower1 = $('.boost-pfs-filter-option-range-slider .noUi-handle-lower').attr('aria-valuenow');
    var lower_new = lower1.replace('.0','');   
    $('.boost-pfs-filter-option-range-slider .noUi-handle-lower .noUi-touch-area').text(lower_new);



    var upper1 = $('.boost-pfs-filter-option-range-slider .noUi-handle-upper').attr('aria-valuenow');
    var upper_new = upper1.replace('.0','');
    $('.boost-pfs-filter-option-range-slider .noUi-handle-upper .noUi-touch-area').text(upper_new);
  }
}, 2000);




$(document).on('mousemove','.boost-pfs-filter-option-range-slider .noUi-handle-lower',function(){  
  var lower = $(this).attr('aria-valuenow');
  var lower_new = lower.replace('.0','');   
  $('.boost-pfs-filter-option-range-slider .noUi-handle-lower .noUi-touch-area').text(lower_new);

  //    $(this).parents('.noUi-origin').parents('.noUi-base').parents('.boost-pfs-filter-option-range-slider').parents('.boost-pfs-filter-block-content-inner').parent().siblings('.boost-pfs-filter-apply-button').trigger('click');
});

$(document).on('mousemove','.boost-pfs-filter-option-range-slider .noUi-handle-upper',function(){  
  var upper = $(this).attr('aria-valuenow');
  var upper_new = upper.replace('.0','');
  $('.boost-pfs-filter-option-range-slider .noUi-handle-upper .noUi-touch-area').text(upper_new);
  //     $(this).parents('.noUi-origin').parents('.noUi-base').parents('.boost-pfs-filter-option-range-slider').parents('.boost-pfs-filter-block-content-inner').parent().siblings('.boost-pfs-filter-apply-button').trigger('click');
}); 

/* Trikot products start */  
$('.product-configurator-wrapper .product-details-inner .product-details-block-wrapper').each(function(i, li) {
    var block_html = $(this);
    var select_html = block_html.find('.product-form__input--dropdown .select_spieler select');
    var option_html = block_html.find('.product-form__input--dropdown .select_spieler select option');
    
    $(select_html).html($(option_html).sort(function(x, y) {
   
    var value_x = $(x).val();
    var arr_x = [];
    arr_x = value_x.split('-');
  
    var value_y = $(y).val();
    var arr_y = [];
    arr_y = value_y.split('-');
  
    var arel = parseInt( arr_x[0]);
    var brel = parseInt(arr_y[0]);             
  
    return arel < brel ? -1 : 1;
    }));
});

$('.product .product__info-container .hidden_product_input.product-form__input--dropdown').each(function(i, li) {
    var block_html = $(this);
    var select_html = block_html.find('.select select');
    var option_html = block_html.find('.select select option');
  
    $(select_html).html($(option_html).sort(function(x, y) {
      var value_x = $(x).val();
      var arr_x = [];
      arr_x = value_x.split('-');
    
      var value_y = $(y).val();
      var arr_y = [];
      arr_y = value_y.split('-');
    
      var arel = parseInt( arr_x[0]);
      var brel = parseInt(arr_y[0]);             
    
      return arel < brel ? -1 : 1;
    }));
  
});
  
if($('.template-product .product-form__input--dropdown .select select').length>0){
  $(".template-product .product-form__input--dropdown .select select").get(0).selectedIndex = 0;
}

$('.hidden_product_input input:checkbox').change(function(){
  var name = $(this).attr('name');
  var index = $(this).attr('option-index');
  var price = $(this).attr('data-price');
  var image = $(this).attr('data-image');
  var $this = $(this);

  if ($(this).is(':checked')) {

    if(name == 'Individuell'){
      $this.parents('.active-product').find('.hidden_field_individuell').removeClass("hidden");            
      $this.parents('.active-product').find('.pro_spieler_no').text('');
      $this.parents('.active-product').find('.pro_spieler_name').text(''); 
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide").removeClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li .thumbnail").removeAttr('aria-current');        
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide:nth-child(2)").addClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(2) .thumbnail").attr('aria-current','true');
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(2) .thumbnail").trigger('click');
      $this.parents('.active-product').find('.thumbnail-slider .slick-thumbnail-slider').slick('slickGoTo',2 );
      
      $this.parents('.active-product').find(".hidden_product_input.product-form__input--dropdown .select select option:selected").prop("selected", false);
            
      var select_index = $this.parents('.active-product').find(".hidden_product_input.product-form__input--dropdown .select select").attr('option-index');
      $this.parents('.active-product').find('#hidden-price-item-' + select_index).text('');

      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(2)').removeClass('hidden');
      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(1)').addClass('hidden');

    }
    if(name == 'Schulterpatch'){
      var html = '<img src="'+ image +'" />'
      $this.parents('.active-product').find('.pro_badges_main .pro_badges_inner').html(html);
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide").removeClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li .thumbnail").removeAttr('aria-current');        
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide:nth-child(1)").addClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").attr('aria-current','true'); 
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").trigger('click');
      $this.parents('.active-product').find('.thumbnail-slider .slick-thumbnail-slider').slick('slickGoTo',0 );

      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(1)').removeClass('hidden');
      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(2)').addClass('hidden');
    }
    if(name == 'Meisterpatch'){
      var html = '<img src="'+ image +'" />'
      $this.parents('.active-product').find('.pro_badges_main .pro_badges_inner').html(html);
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide").removeClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li .thumbnail").removeAttr('aria-current');        
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide:nth-child(1)").addClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").attr('aria-current','true'); 
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").trigger('click');
      $this.parents('.active-product').find('.thumbnail-slider .slick-thumbnail-slider').slick('slickGoTo',0 );

      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(1)').removeClass('hidden');
      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(2)').addClass('hidden');
    }
    if(name == 'EL-Patch'){
      var html = '<img src="'+ image +'" />'
      $this.parents('.active-product').find('.pro_left_badges_main .pro_left_badges_inner').html(html);
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide").removeClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li .thumbnail").removeAttr('aria-current');        
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide:nth-child(1)").addClass("is-active");
      
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").attr('aria-current','true'); 
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").trigger('click');
      $this.parents('.active-product').find('.thumbnail-slider .slick-thumbnail-slider').slick('slickGoTo',0 );

      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(1)').removeClass('hidden');
      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(2)').addClass('hidden');
    }
    if(name == 'SL -Patch' || name == 'SL -PATCH'){
      var html = '<img src="'+ image +'" />'
      $this.parents('.active-product').find('.pro_left_badges_main .pro_left_badges_inner').html(html);
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide").removeClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li .thumbnail").removeAttr('aria-current');        
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide:nth-child(1)").addClass("is-active");
      
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").attr('aria-current','true'); 
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").trigger('click');
      $this.parents('.active-product').find('.thumbnail-slider .slick-thumbnail-slider').slick('slickGoTo',0 );

      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(1)').removeClass('hidden');
      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(2)').addClass('hidden');
    }
    if(name == 'SL-Patch'){
      var html = '<img src="'+ image +'" />'
      $this.parents('.active-product').find('.pro_left_badges_main .pro_left_badges_inner').html(html);
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide").removeClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li .thumbnail").removeAttr('aria-current');        
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide:nth-child(1)").addClass("is-active");
      
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").attr('aria-current','true'); 
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").trigger('click');
      $this.parents('.active-product').find('.thumbnail-slider .slick-thumbnail-slider').slick('slickGoTo',0 );

      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(1)').removeClass('hidden');
      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(2)').addClass('hidden');
    }
    if(name == 'MG-Patch'){
      var html = '<img src="'+ image +'" />';
      $this.parents(".active-product").find(".pro_right_badges_main").removeClass('badge_type_'+handleize(name));
      $this.parents('.active-product').find('.pro_right_badges_main .pro_right_badges_inner').html(html);
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide").removeClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li .thumbnail").removeAttr('aria-current');        
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide:nth-child(1)").addClass("is-active");
      
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").attr('aria-current','true'); 
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").trigger('click');
      $this.parents('.active-product').find('.thumbnail-slider .slick-thumbnail-slider').slick('slickGoTo',0 );

      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(1)').removeClass('hidden');
      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(2)').addClass('hidden');
    }
    if(name == 'Brustpatch' || name == 'CS - Patch' || name == 'CS-Patch' || name == 'AXA-Patch' || name == "UBS"  || name == "UBS gold" || name == 'AXA' || name == 'AXA-Weiss' || name.includes('AXA')){
      $(this).parents('.hidden_product_input').find(':input').prop('checked', false);
      $(this).prop('checked', true);
      var html = '<img src="'+ image +'" />'
      $this.parents('.active-product').find('.pro_brustpatch_main .pro_brustpatch_inner').html(html);
      $this.parents(".active-product").find(".pro_brustpatch_main").addClass('badge_type_'+handleize(name));
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide").removeClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li .thumbnail").removeAttr('aria-current');        
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide:nth-child(1)").addClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").attr('aria-current','true'); 
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(1) .thumbnail").trigger('click');
      $this.parents('.active-product').find('.thumbnail-slider .slick-thumbnail-slider').slick('slickGoTo',0 );

      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(1)').removeClass('hidden');
      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(2)').addClass('hidden');
    }
    if(name == 'Fairdruck-Patch'){
      var html = '<img src="'+ image +'" />'
      $this.parents('.active-product').find('.pro_middle_badges_main .pro_middle_badges_inner').html(html);
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide").removeClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li .thumbnail").removeAttr('aria-current');        
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide:nth-child(2)").addClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(2) .thumbnail").attr('aria-current','true');
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(2) .thumbnail").trigger('click');
      $this.parents('.active-product').find('.thumbnail-slider .slick-thumbnail-slider').slick('slickGoTo',2 );
      
      $this.parents('.active-product').find(".hidden_product_input.product-form__input--dropdown .select select option:selected").prop("selected", false);
            
      var select_index = $this.parents('.active-product').find(".hidden_product_input.product-form__input--dropdown .select select").attr('option-index');
      $this.parents('.active-product').find('#hidden-price-item-' + select_index).text('');

      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(2)').removeClass('hidden');
      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(1)').addClass('hidden');
    }
    
    if(price){
      $this.parents('.active-product').find('#hidden-price-item-' + index).text(price);  
    }
    else
    {
      $this.parents('.active-product').find('#hidden-price-item-' + index).text('');  
    }
  } else {
    if(name == 'Individuell'){
      $this.parents('.active-product').find('.hidden_field_individuell').addClass("hidden"); 
      $this.parents('.active-product').find('.individuell-nummer').val('');
      $this.parents('.active-product').find('.individuell-name').val('');
      $this.parents('.active-product').find('.cart-error-text').text('');
    }

    $this.parents('.active-product').find('#hidden-price-item-' + index).text('');  

    if(name == 'Schulterpatch'){            
      $this.parents('.active-product').find('.pro_badges_main .pro_badges_inner').html('');
    }
    if(name == 'Meisterpatch'){            
      $this.parents('.active-product').find('.pro_badges_main .pro_badges_inner').html('');
    }
    if(name == 'EL-Patch'){            
      $this.parents('.active-product').find('.pro_left_badges_main .pro_left_badges_inner').html('');
    }
    if(name == 'MG-Patch'){            
      $this.parents('.active-product').find('.pro_right_badges_main .pro_right_badges_inner').html('');
      $this.parents(".active-product").find(".pro_right_badges_main").removeClass('badge_type_'+handleize(name));
    }
    if(name == 'SL -Patch' || name == 'SL-Patch' || name == 'SL -PATCH'){            
      $this.parents('.active-product').find('.pro_left_badges_main .pro_left_badges_inner').html('');
    }
    if(name == 'Brustpatch' || name == 'CS - Patch' || name == 'CS-Patch' || name == 'AXA-Patch' || name == "UBS" || name == "UBS gold" || name == 'AXA' || name == 'AXA-Weiss' || name.includes('AXA')){            
      $this.parents('.active-product').find('.pro_brustpatch_main .pro_brustpatch_inner').html('');
      $this.parents(".active-product").find(".pro_brustpatch_main").removeClass('badge_type_'+handleize(name));
    }
    if(name == 'Fairdruck-Patch'){
      $this.parents('.active-product').find('.pro_middle_badges_main .pro_middle_badges_inner').html('');
    }
  }

});

$(".product-form__input--dropdown .select select").change(function(){
  var name = $(this).attr('name');
  var index = $(this).attr('option-index');
  var price = $('option:selected', this).attr('data-price');
  var $this = $(this);

  if(name == 'options[Spieler]' || name == 'options[Spielerinnen]' || name == 'options[frauen]' || name == 'options[Frauen 24/25]'){
    var value = $(this).val();        
    if(value && value != 0){
      var arr = [];
      var name = [];
      arr = value.split(' - ');
      name = arr[1].split(' ');         
      // var s_no = value.slice(value.indexOf('[') +1,value.indexOf(']'));
      // var s_name = value.replace(/ *\[[^\]]*]/, '');
      $this.parents('.active-product').find('.pro_spieler_no').text(arr[0]);
      $this.parents('.active-product').find('.pro_spieler_name').text(arr[1]);        
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide").removeClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li .thumbnail").removeAttr('aria-current');        
      $this.parents('.active-product').find(".product__media-list.slider .slider__slide:nth-child(2)").addClass("is-active");
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(2) .thumbnail").attr('aria-current','true'); 
      $this.parents('.active-product').find(".thumbnail-list.slider li:nth-child(2) .thumbnail").trigger('click');
      $this.parents('.active-product').find('.thumbnail-slider .slick-thumbnail-slider').slick('slickGoTo',1 );
      
      $this.parents('.active-product').find('.hidden_field_individuell').addClass("hidden");
      $this.parents('.active-product').find('.individuell-nummer').val('');
      $this.parents('.active-product').find(".individuell-name").val(''); 
      $this.parents('.active-product').find('.cart-error-text').text('');

      $this.parents('.active-product').find(".hidden_product_input input[name='Individuell']:checkbox").prop('checked',false);
      var checkbox_index = $this.parents('.active-product').find(".hidden_product_input input[name='Individuell']").attr('option-index');
      $this.parents('.active-product').find('#hidden-price-item-' + checkbox_index).text('');  

      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(2)').removeClass('hidden');
      $this.parents('.active-product').find('.product-thumbnail-wrapper .slider__slide:nth-child(1)').addClass('hidden');

    }
    else {
      $this.parents('.active-product').find('.pro_spieler_no').text('');
      $this.parents('.active-product').find('.pro_spieler_name').text('');       
    }

  }  
  if(price){
    $this.parents('.active-product').find('#hidden-price-item-' + index).text(price);  
  }
  else
  {
    $this.parents('.active-product').find('#hidden-price-item-' + index).text('');  
  }

}); 

$(".individuell-nummer").on("change keyup focusout ", function(){
  var $this = $(this);
  var n = $(this).val();

  if (n < 0) {
    $this.parents('.active-product').find('.individuell-nummer').val(0);
  } else if (n > 99) {
    $this.parents('.active-product').find('.individuell-nummer').val(99);
  }

  $this.parents('.active-product').find('.pro_spieler_no').text(n);

});


$(".individuell-name").on("change keyup focusout ", function(){
  var $this = $(this);
  var txtInput = $(this).val();
  var txtInput_lower = txtInput.toLowerCase();

  var badWord = "fuck";        
  if(txtInput_lower.indexOf(badWord) != -1){
    //           console.log(txtInput_lower);
    var txtInputnew = txtInput_lower.replace(badWord,'');
    $this.parents('.active-product').find(".individuell-name").val(txtInputnew);
    $this.parents('.active-product').find('.pro_spieler_name').text(txtInputnew);
  }else {
    $this.parents('.active-product').find('.pro_spieler_name').text(txtInput);
  } 

});
/* Trikot products end */  
  
$('.kunde_slider').slick({
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow:'<button type="button" class="slider-button a-left control-c prev slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="11.067" height="22.134" viewBox="0 0 11.067 22.134" class="icon icon-caret"><path id="Icon_ionic-md-arrow-dropdown" data-name="Icon ionic-md-arrow-dropdown" d="M0,0,11.067,11.067,22.134,0Z" transform="translate(11.067) rotate(90)" fill="#currentColor"></path></svg></button>',
  nextArrow: '<button type="button" class="slider-button a-right control-c next slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="11.067" height="22.134" viewBox="0 0 11.067 22.134" class="icon icon-caret"><path id="Icon_ionic-md-arrow-dropdown" data-name="Icon ionic-md-arrow-dropdown" d="M0,0,11.067,11.067,22.134,0Z" transform="translate(11.067) rotate(90)" fill="#currentColor"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        arrows: true,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 769,
      settings: {
        arrows: true,
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        slidesToShow: 1,

      }
    }
  ] 
});

$('.liga-group-wrapper').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  prevArrow:'<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="left"><path d="M4.409 11l9.061-9.061 2.121 2.121-6.939 6.939 6.939 6.939-2.121 2.121z" fill="#fff"></path></svg>',
  nextArrow:'<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="right"><path d="M8.53 20.061l-2.121-2.121 6.939-6.939-6.939-6.939 2.121-2.121 9.061 9.061z" fill="#fff"></path></svg>',
});

var Ersatzbank = [ "Ersatzbank","BENCH","BANC DE REMPLACEMENT" ];
var Aufstellung = [ "Aufstellung","LINE-UP","COMPOSITION" ];
  
$('.slick-aufstellung').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  prevArrow:'<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Prev" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="left"><path d="M4.409 11l9.061-9.061 2.121 2.121-6.939 6.939 6.939 6.939-2.121 2.121z" fill="#fff"></path></svg><span>'+Ersatzbank[lang]+'</span></button>',
  nextArrow:'<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="right"><path d="M8.53 20.061l-2.121-2.121 6.939-6.939-6.939-6.939 2.121-2.121 9.061 9.061z" fill="#fff"></path></svg><span>'+Ersatzbank[lang]+'</span></button>'
});

$('.slick-aufstellung').slick('slickGoTo', 1);  

// On before slide change
$(document).on('beforeChange','.slick-aufstellung',function(event, slick, currentSlide, nextSlide){ 
  if(currentSlide == 1){
    $('.slick-aufstellung .slick-prev span').text(Aufstellung[lang]);
    $('.slick-aufstellung .slick-next span').text(Aufstellung[lang]);
  }else {
    $('.slick-aufstellung .slick-prev span').text(Ersatzbank[lang]);
    $('.slick-aufstellung .slick-next span').text(Ersatzbank[lang]);
  }
});

$(document).on('click','ul.match-center-tabs li',function(){  
    var tab_id = $(this).attr('data-id');
    $('ul.match-center-tabs li').removeClass('active');
    $('.match-center-main .tab-content .tab-pane').removeClass('active slide-out');
    $(this).addClass('active');
    $(tab_id).addClass('active slide-out');    
});

$('.slick-aufstellung-mobile').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false
});

$('.statistik-mobile-slider').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false
});

/*
  $('#shopify-section-header-website .megaLinkContainer').each(function (){
      var countMenuli = $(this).children('.megaLinkBox');
      if(countMenuli.length > 4){
      	$(this).addClass('column2');
      }
    });
  */
});
var tabLabels = document.querySelectorAll("#tabs li");
var tabPanes = document.getElementsByClassName("tab-contents");

function activateTab(e) {
  e.preventDefault();

  // Deactivate all tabs
  tabLabels.forEach(function(label, index){
    label.classList.remove("active");
  });
  [].forEach.call(tabPanes, function(pane, index){
    pane.classList.remove("active");
  });

  // Activate current tab
  e.target.parentNode.classList.add("active");
  var clickedTab = e.target.getAttribute("href");
  document.querySelector(clickedTab).classList.add("active");
}

// Apply event listeners
tabLabels.forEach(function(label, index){
  label.addEventListener("click", activateTab);
});


$('.footer-block__details-content li a.newsletter').bind("click", function () {
  //Fade In Modal Pop Up
  $(".overlay, #newsletter_popup").fadeIn();
});

//On clicking the modal background
$(".overlay, .closeBtn").bind("click", function () {
  $(".modal").fadeOut();
});

$('.template-index .news-filter .multicolumn-list__item').eq(3).css('visibility','hidden');


/*var settings = {
  "url": "https://fczurich-data.b-cdn.net/api/v1/news?page[number]=1&page[size]=25&sort=createdAt",
  "method": "GET",
  "timeout": 0,
  "headers": {
    "Accept": "application/vnd.api+json",
  }
};




$.ajax(settings).done(function (responsea) {
  var lastPage = responsea.meta.page.lastPage;*/
//   lastPage = '1';

if($('.online-website').length > 0 || $('.template-index').length > 0){

	var homenz = '',
    	homenzth = '';

  var settings = {
    "url": "https://fczurich-data.b-cdn.net/api/v1/news?page[number]=1&page[size]=1&filter[isActive]=1&sort=-publishDate&filter[isSpecialArticle]=1&filter[isLightVersion]=true",
    "method": "GET",
    "timeout": 0,
    "headers": {
      "Accept": "application/vnd.api+json"
    },
  };
  
  $.ajax(settings).done(function (response) {
    var totalData = response.data.length;
    // home_destroyCarousel();
    // setTimeout(function(){
    //   home_slickCarousel();
    // },500);
    for(var a=0; a<totalData; a++){
      var json_response = response.data[a].attributes;
      
      var url = response.data[a].id;
      if(json_response.urlHandle != null){
        url = json_response.urlHandle;
      }
      
      var imagesrc = "";
      if(json_response.optimizedImage != null){
        imagesrc = json_response.optimizedImage;
      }else if(json_response.image != null){
        imagesrc = json_response.image;
      }else{
        imagesrc = 'https://cdn.shopify.com/s/files/1/0565/2201/4813/files/blank-header-image-blue.jpg';
      }

      var focusXPercentage = "";
      if(json_response.focusXPercentage != null){
        focusXPercentage = json_response.focusXPercentage+'%';
      }else {
        focusXPercentage = 'center';
      }

      var focusYPercentage = "";
      if(json_response.focusYPercentage != null){
        focusYPercentage = json_response.focusYPercentage+'%';
      }else {
        focusYPercentage = 'center';
      }

      var object_fit = "cover";
      if(json_response.isFullWidth != 1){
        var object_fit = "contain";
        focusXPercentage = 'center';
        focusYPercentage = 'center';
      }
      
      var title = jQuery.trim(json_response.name);
      // homenz += '<div class="slider-block">';
          homenz += '<div class="slider__media" data-isFullWidth="'+json_response.isFullWidth+'">';
              homenz += '<img src="'+imagesrc+'" class="lazy" loading="lazy" alt="" style="object-position: '+focusXPercentage+' '+focusYPercentage+';object-fit:'+object_fit+';">';
          homenz += '</div>';
          homenz += '<div class="slideshow__text-wrapper banner__content page-width">';
            homenz += '<div class="slideshow__text banner__box content-container content-container--full-width-mobile">';
                homenz += '<h2 class="banner__heading"><a href="/pages/news/'+url+'" class="link--title">'+title+'</a></h2>';
            homenz += '</div>';
          homenz += '</div>';
        // homenz += '</div>';

    }
    // $('.website-home-slider-style-two .slider-for').removeClass('slider-for-loading');
    $('.website-home-slider-style-two .slider-for .slider-block[data-index="'+(a)+'"]').html(homenz);
    $('.website-home-slider-style-two .slider-for .slider-block[data-index="'+(a)+'"]').addClass('slide--loaded');
    $('.website-home-slider-style-two').addClass('homepage-slider-loaded');
    // $('.website-home-slider-style-two .slider-nav').html(homenzth);
    
    
    setTimeout(function(){
      $('.website-home-slider-style-two .slider-for-loading').remove();
    },500);
  });

  const load_next_news = setInterval(function(){
    if(jQuery('.homepage-slider-loaded').length > 0){

        $(".homepage-slider-loaded .slider-for").on('init reInit afterChange', function(event, slick, currentSlide){
          //change color here
          currentSlide++;
          if($('.website-home-slider-style-two .slider-for .slider-block[data-index="'+currentSlide+'"]').hasClass('slide--loaded')){
            
          }else{
        
          var settings = {
            "url": "https://fczurich-data.b-cdn.net/api/v1/news?page[number]="+currentSlide+"&page[size]=1&filter[isActive]=1&sort=-publishDate&filter[isSpecialArticle]=1&filter[isLightVersion]=true",
            "method": "GET",
            "timeout": 0,
            "headers": {
              "Accept": "application/vnd.api+json"
            },
          };
          
          $.ajax(settings).done(function (response) {
            var totalData = response.data.length;
            
            // for(var a=0; a<totalData; a++){
            for (var a = 0, b = 1; a < totalData; a++, b++) {
              var homenews = '';
              var json_response = response.data[a].attributes;
              
              var url = response.data[a].id;
              if(json_response.urlHandle != null){
                url = json_response.urlHandle;
              }
              
              var imagesrc = "";
              if(json_response.optimizedImage != null){
                imagesrc = json_response.optimizedImage;
              }else if(json_response.image != null){
                imagesrc = json_response.image;
              }else{
                imagesrc = 'https://cdn.shopify.com/s/files/1/0565/2201/4813/files/blank-header-image-blue.jpg';
              }
        
              var focusXPercentage = "";
              if(json_response.focusXPercentage != null){
                focusXPercentage = json_response.focusXPercentage+'%';
              }else {
                focusXPercentage = 'center';
              }
        
              var focusYPercentage = "";
              if(json_response.focusYPercentage != null){
                focusYPercentage = json_response.focusYPercentage+'%';
              }else {
                focusYPercentage = 'center';
              }
        
              var object_fit = "cover";
              if(json_response.isFullWidth != 1){
                var object_fit = "contain";
                focusXPercentage = 'center';
                focusYPercentage = 'center';
              }
              
              var title = jQuery.trim(json_response.name);
              // homenz += '<div class="slider-block">';
                  homenews += '<div class="slider__media" data-isFullWidth="'+json_response.isFullWidth+'">';
                      homenews += '<img src="'+imagesrc+'" class="lazy" loading="lazy" alt="" style="object-position: '+focusXPercentage+' '+focusYPercentage+';object-fit:'+object_fit+';">';
                  homenews += '</div>';
                  homenews += '<div class="slideshow__text-wrapper banner__content page-width">';
                    homenews += '<div class="slideshow__text banner__box content-container content-container--full-width-mobile">';
                        homenews += '<h2 class="banner__heading"><a href="/pages/news/'+url+'" class="link--title">'+title+'</a></h2>';
                    homenews += '</div>';
                  homenews += '</div>';
                // homenz += '</div>';
               
              $('.website-home-slider-style-two .slider-for .slider-block[data-index="'+currentSlide+'"]').html(homenews);
              $('.website-home-slider-style-two .slider-for .slider-block[data-index="'+currentSlide+'"]').addClass('slide--loaded');
            }
            })
          }
        });
      clearInterval(load_next_news);
    }
  },1000);
  
}

const formatDate = (date,syear='true') => {
  // const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];
  var newDate = date.split(' ');
  var newTime = newDate[1].split(':');
  
  date = newDate[0]+'T'+newDate[1]+'Z';
  var d = new Date(date);
  
  // var month = (monthNames[d.getUTCMonth()]).toString();
  if(currentLang == 'fr'){      
    const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin","Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
    const days = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  }
  else if(currentLang == 'en'){      
    const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  } 
  else if(currentLang == 'de') {     
    const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];
    const days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  }
  
  var day = d.getUTCDate().toString();
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();
  if (month.length < 2) {
    month = '0' + month;
  }

  var min = '',
    h = '';
  if (day.length < 2) {
    day = '0' + day;
  }
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(syear == 'false'){
    year = newTime[0]+':'+newTime[1];
  }
  
  return (day+'. '+month+' '+ year);
}

const regularDate = (date) => {
  // var newDate = date.split(' ');
  // var newTime = newDate[1].split(':');
  
  // date = newDate[0]+'T'+newDate[1]+'Z';
  var d = new Date(date);
  
  var month = d.getUTCMonth()+1;
  var day = d.getUTCDate();
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();
  if (month.length < 2) {
    month = '0' + month;
  }

  if (day.length < 2) {
    day = '0' + day;
  }
  return (day+'.'+ month+'.'+ year);
}

function formatDateString (date,format='regular',time='') {
  // var days = ["SO", "MO", "DI", "MI", "DO", "FR", "SA"];

  var newDate = date.split(' ');
  var newTime = newDate[1].split(':');
  
  date = newDate[0]+'T'+newDate[1]+'Z';
  var d = new Date(date);

  if(currentLang == 'fr'){      
    var days = ["DIM", "LUN", "MAR", "MER", "JEU", "ven", "sam"];
    var dayname = days[d.getDay()];
  }
  else if(currentLang == 'en'){      
    var days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    var dayname = days[d.getDay()];
  } 
  else if(currentLang == 'de') {     
    var days = ["SO", "MO", "DI", "MI", "DO", "FR", "SA"];
    var dayname = days[d.getDay()];
  }
  
  var month = d.getUTCMonth()+1;
  var day = d.getUTCDate();
  // var dayname = days[d.getUTCDay()];
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();

  if (month.length < 2) {
    month = '0' + month;
  }
  
  var min = '',
      h = '',
      dt = '',
      mt = '',
      tm = '';

  if (day.length < 2) {
    day = '0' + day;
  }
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(day < 10){
  	dt = 0;
  }
  if(month < 10){
  	mt = 0;
  }
  if(time=='false'){
    tm = '';
  }else{
    // tm = ', '+h+hour+':'+min+minute;
    tm = ', '+newTime[0]+':'+newTime[1];
  }

  
  
  return (dayname+', '+dt+day+'.'+ mt+month+'.'+ year+tm);
}

const formatDateStringWithMonth = (date,format='') => {

   var newDate = date.split(' ');
   var newTime = newDate[1].split(':');  
   date = newDate[0]+'T'+newDate[1]+'Z';  
   var d = new Date(date);
  
    if(currentLang == 'fr'){
      const days = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
      const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin","Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
      var month = (monthNames[d.getUTCMonth()]).toString();
      var dayname = days[d.getUTCDay()];    
    }
    else if(currentLang == 'en'){
      const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"]; 
      var month = (monthNames[d.getUTCMonth()]).toString();
      var dayname = days[d.getUTCDay()];
    } else if(currentLang == 'de') {
      const days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
      const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];
      var month = (monthNames[d.getUTCMonth()]).toString();
      var dayname = days[d.getUTCDay()];
    }
 
   //console.log("lang",currentLang,d.getUTCMonth());
   
    var day = d.getUTCDate();    
    var year = d.getUTCFullYear();
    var hour = d.getUTCHours();
    var minute = d.getUTCMinutes();
    
    if (month.length < 2) {
      month = '0' + month;
    }
  
  var min = '',
      h = '',
      dt = '';

  if (day.length < 2) {
    day = '0' + day;
  }
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(day < 10){
  	dt = 0;
  }
  if(newTime[0] == '00' && newTime[1] == '00'){
    var timeString = ' (noch nicht def. fixiert)';
  }else{
    var timeString = ', '+newTime[0]+':'+newTime[1];
  }
  return (dayname+', '+dt+day+'. '+ month+' '+ year+timeString);
}

const formatDateStringforfuturematch = (date,format='') => {
  // const days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
  // const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];
  
  var isValid = isValidDate(date.toString());
  if(isValid == false){
    var d = new Date(date);
  }
  else {
    var d = date;  
  }
  //console.log(isValid,d);
  
  // var month = (monthNames[d.getMonth()]).toString();
  var day = d.getDate();
  // var dayname = days[d.getDay()];
  var year = d.getFullYear();
  var hour = d.getHours();
  var minute = d.getMinutes();
  
  if(currentLang == 'fr'){      
    const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin","Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
    const days = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  }
  else if(currentLang == 'en'){      
    const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  } 
  else if(currentLang == 'de') {     
    const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];
    const days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  }
  if (month.length < 2) {
    month = '0' + month;
  }
  
  var min = '',
      h = '',
      dt = '';

  if (day.length < 2) {
    day = '0' + day;
  }
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(day < 10){
  	dt = 0;
  }
  return (dayname+', '+dt+day+'. '+ month+' '+ year+', '+h+hour+':'+min+minute);
}

function isValidDate(s) {
  var bits = s.split('/');
  var d = new Date(bits[2] + '/' + bits[1] + '/' + bits[0]);
  return !!(d && (d.getMonth() + 1) == bits[1] && d.getDate() == Number(bits[0]));
}

function addDays(theDate, days) {
    return new Date(theDate.getTime() + days*24*60*60*1000);
}

function changeTimeZone(date, timeZone) {
  if (typeof date === 'string') {
    return new Date(
      new Date(date).toLocaleString('en-US', {
        timeZone,
      }),
    );
  }

  return new Date(
    date.toLocaleString('en-US', {
      timeZone,
    }),
  );
}

const formatDateStringforsflmatch = (date,format='') => {    

    const d = changeTimeZone(new Date(date), 'Europe/Zurich');
    
    //var month = (monthNames[d.getMonth()]).toString();
    var day = d.getDate();
    
    var year = d.getFullYear();
    var hour = d.getHours();
    var minute = d.getMinutes();

  if(currentLang == 'fr'){      
    const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin","Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
    const days = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  }
  else if(currentLang == 'en'){      
    const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  } 
  else if(currentLang == 'de') {     
    const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];
    const days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  }
  
  if (month.length < 2) {
    month = '0' + month;
  }
   
  var min = '',
      h = '',
      dt = '';

  if (day.length < 2) {
    day = '0' + day;
  }
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(day < 10){
  	dt = 0;
  }
  return ('<span class="date_date">'+dayname+', '+dt+day+'. '+ month+' '+ year+'</span><span class="date_time">'+h+hour+':'+min+minute+'</span>');
}

const formatDateStringfor_match = (date,format='') => {

    const d = new Date(date);
    //var month = (monthNames[d.getMonth()]).toString();
    var day = d.getDate();
    
    var year = d.getFullYear();
    var hour = d.getHours();
    var minute = d.getMinutes();

  if(currentLang == 'fr'){      
    const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin","Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
    const days = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  }
  else if(currentLang == 'en'){      
    const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  } 
  else if(currentLang == 'de') {     
    const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];
    const days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
    var month = (monthNames[d.getUTCMonth()]).toString();
    var dayname = days[d.getDay()];
  }
  
  if (month.length < 2) {
    month = '0' + month;
  }
   
  var min = '',
      h = '',
      dt = '';

  if (day.length < 2) {
    day = '0' + day;
  }
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(day < 10){
  	dt = 0;
  }
  return ('<span class="date_date">'+dayname+', '+dt+day+'. '+ month+' '+ year+'</span><span class="date_time">'+h+hour+':'+min+minute+'</span>');
}

const formatDateStringforgameday = (date,format='') => {
  // const days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
  const monthNames = ["01", "02", "03", "04", "05", "06","07", "08", "09", "10", "11", "12"];
 
    var d = new Date(date);   
    var month = (monthNames[d.getUTCMonth()]).toString();
    var day = d.getUTCDate();
    // var dayname = days[d.getUTCDay()];
    var year = d.getUTCFullYear();
    var hour = d.getUTCHours();
    var minute = d.getUTCMinutes();

  if(currentLang == 'fr'){      
    const days = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
    var dayname = days[d.getDay()];
  }
  else if(currentLang == 'en'){      
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var dayname = days[d.getDay()];
  } 
  else if(currentLang == 'de') {     
    const days = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
    var dayname = days[d.getDay()];
  }
 
  var min = '',
      h = '',
      dt = '';
 
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(day < 10){
  	dt = 0;
  }
  return (dayname+' | '+dt+day+'.'+ month+'.'+ year);
}

const monthyear = (date) => {
  
  var newDate = date.split(' ');
  var newTime = newDate[1].split(':');  
  date = newDate[0]+'T'+newDate[1]+'Z';
  var d = new Date(date);  
  var year = d.getUTCFullYear();

  if(currentLang == 'fr'){      
    const monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin","Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
    var month = (monthNames[d.getUTCMonth()]).toString();         
  }
  else if(currentLang == 'en'){      
    const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"]; 
    var month = (monthNames[d.getUTCMonth()]).toString();      
  } else if(currentLang == 'de') {     
    const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];
    var month = (monthNames[d.getUTCMonth()]).toString();      
  }
 
  if (month.length < 2) {
    month = '0' + month;
  }
  return ( month+' '+ year);
}

function getFormatedDate(dt){
  var tempDate = new Date(dt);
  var dy = tempDate.getDate();
  var m = tempDate.getMonth()+1;

  if(dy < 9){
    dy = '0'+dy;
  }
  if(m < 9){
    m = '0'+m;
  }
  var formattedDate = [dy, m, tempDate.getFullYear()].join('/');
  return formattedDate;
}

/*$(window).on('load',function(){
  var categoryTitle = '<div class="boost-pfs-filter-option-title"><span class="boost-pfs-filter-option-title-text">KATEGORIE</span></div>';
  $('.boost-pfs-filter-option-kategorie .boost-pfs-filter-option-title').before(categoryTitle);
});*/

$('#scroll').click(function(){ 
  $("html, body").animate({ scrollTop: 0 }, '600'); 
  return false; 
});

settings = {
  //Model Popup
  objModalPopupBtn: ".modalButton",
  objModalCloseBtn: ".overlay, .closeBtn",
  objModalDataAttr: "data-popup"
}  
$(document).on('click',settings.objModalPopupBtn,function(){
  event.preventDefault();
  
  if ($(this).attr(settings.objModalDataAttr)) {

    var strDataPopupName = $(this).attr(settings.objModalDataAttr);


    //Fade In Modal Pop Up
    $(".overlay, #" + strDataPopupName).fadeIn();

  }
});

//On clicking the modal background
$(document).on('click',settings.objModalCloseBtn,function(){
  $(".modal").fadeOut();
});


resizeWindow();
$(window).resize(function(){
  resizeWindow();
});

function resizeWindow(){
  if($(window).width() < 768){
    $('.news-filter .multicolumn-list__item').each(function(i){
      if(i>=8){
        $(this).addClass('hidden');
      }else{
      	$(this).removeClass('hidden');
      }
    });
  }else{
    /*$('.news-filter .multicolumn-list__item').each(function(i){
      $(this).removeClass('hidden');
    });*/
  }
}

$(document).on('click','#cart_agree',function(){
  if ($('input#cart_agree').is(':checked')) {
    $('.cart__checkout-button').attr('type','submit');
    $('.cart__tos .error').addClass('hidden');
  }else{
    $('.cart__checkout-button').attr('type','button');
    $('.cart__tos .error').removeClass('hidden');
  }
});

$(document).on('click','.cart__checkout-button[type="button"]',function(){
	$('.cart__tos .error').removeClass('hidden');
});

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2]);
}


// homepage news slider
function home_slickCarousel() {
  $('.website-home-slider-style-two .slider-for').not('.slick-initialized').slick({
     slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.slider-nav',
    autoplay: true,
    autoplaySpeed: 5000,
      pauseOnHover: false,
      pauseOnFocus: false,
    dots: true,
  });
  $('.website-home-slider-style-two .slider-nav').not('.slick-initialized').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    centerMode: false,
    focusOnSelect: true,
    verticalSwiping:true,
    vertical:true
  });
}


function home_destroyCarousel() {
  if ($('.website-home-slider-style-two .slider-for').hasClass('slick-initialized')) {
    $('.website-home-slider-style-two .slider-for').slick('destroy');
  }
  if ($('.website-home-slider-style-two .slider-nav').hasClass('slick-initialized')) {
    $('.website-home-slider-style-two .slider-nav').slick('destroy');
  }
}

function handleize(Text){
  return Text
  .toLowerCase()
  .replace(/ /g,'-')
  .replace(/[^\w-]+/g,'')
  ;
}

/*$(document).ready(function(){
  if($('.men-team.next-match-wrapper.match-loaded').length <= 0){
    $('.men-team.next-match-wrapper').addClass('match-loaded');
    var settings = {
      "url": "https://fczurich-data.b-cdn.net/api/v1/aico-matches?filter[season.name]=2022/2023&filter[gender]=man&filter[isLightVersion]=true&filter[isUpcoming]=true&page[size]=3",
      "method": "GET",
      "timeout": 0,
      "headers": {
        "Accept": "application/vnd.api+json",
        "Content-Type": "application/vnd.api+json"
      },
    };
    
    $.ajax(settings).done(function (response) {
      var data = response.data;
      var d2 = new Date();
      var html = '';
      html += '<table class="table">';
         html += '<tbody>';
            html += '<tr>';
                html += '<th>DATUM</th>';
                html += '<th>VS</th>';
            html += '</tr>';
          var temp = 1,
              tempB = 1;
          for(var a=0; a<data.length;a++){
            let nextMatch = data[a].attributes;
            var newDate = nextMatch.date.split(' ');
            var newTime = newDate[1].split(':');
  
            var date = newDate[0]+'T'+newDate[1]+'Z';
            var d1 = new Date(date);
              
            html += '<tr>';
            html += '<td>'+formatDateString(nextMatch.date)+'</td>';
            html += '<td>';
            html += '<div class="team-d-wrp">';
                html += '<div class="team-one">';
                    if(nextMatch.homeClub != null){
                    html += '<span class="team-logo">';
                      if(nextMatch.homeClub.shortName == 'FCZ'){
                        html += '<svg xmlns="http://www.w3.org/2000/svg" width="13.95" height="12.877" viewBox="0 0 13.95 12.877">';
                        html += '<path id="Icon_ionic-md-home" data-name="Icon ionic-md-home" d="M8.74,17.377V13.085H11.96v4.292h3.273V10.938h2.093L10.35,4.5,3.375,10.938H5.468v6.438Z" transform="translate(-3.375 -4.5)" fill="#003da5"></path>';
                        html += '</svg>';
                      }else{
                        html += '<svg xmlns="http://www.w3.org/2000/svg" width="13.949" height="13.949" viewBox="0 0 13.949 13.949">';
                        html += '<path id="Icon_awesome-bus" data-name="Icon awesome-bus" d="M13.3,3.487h-.218V2.18c0-1.221-2.7-2.18-6.1-2.18S.872.959.872,2.18V3.487H.654A.654.654,0,0,0,0,4.141v2.18a.654.654,0,0,0,.654.654H.872v4.359a.872.872,0,0,0,.872.872v.872a.872.872,0,0,0,.872.872h.872a.872.872,0,0,0,.872-.872v-.872H9.59v.872a.872.872,0,0,0,.872.872h.872a.872.872,0,0,0,.872-.872v-.872h.174a.688.688,0,0,0,.7-.7V6.975H13.3a.654.654,0,0,0,.654-.654V4.141A.654.654,0,0,0,13.3,3.487ZM3.051,10.9a.872.872,0,1,1,.872-.872A.872.872,0,0,1,3.051,10.9Zm.436-3.051a.872.872,0,0,1-.872-.872V3.487a.872.872,0,0,1,.872-.872h6.975a.872.872,0,0,1,.872.872V6.975a.872.872,0,0,1-.872.872ZM10.9,10.9a.872.872,0,1,1,.872-.872A.872.872,0,0,1,10.9,10.9Z" fill="#ae9357"></path>';
                        html += '</svg>';
                      }
                    html += '</span>';
                    if(nextMatch.homeClub.shortName == 'FCZ'){
                       html += nextMatch.guestClub.name;
                      //html += '<img src="'+nextMatch.guestClub.logo+'" alt="" width="25">';
                    }else{
                       html += nextMatch.homeClub.name;
                      //html += '<img src="'+nextMatch.homeClub.logo+'" alt="" width="25">';
                    }
                    }
                html += '</div>';
            html += '</div>';
            html += '</td>';
            html += '</tr>';
             
          }
        html += '</tbody>';
      html += '</table>';
      $('.men-team.next-match-wrapper .match-details-wrapper').html(html);
    });
  }

  // woman next matches
  if($('.women-team.next-match-wrapper.match-loaded').length <= 0){
    $('.women-team.next-match-wrapper').addClass('match-loaded');
    var settings = {
      "url": "https://fczurich-data.b-cdn.net/api/v1/aico-matches?filter[season.name]=2022/2023&filter[gender]=woman&filter[isLightVersion]=true&filter[isUpcoming]=true&page[size]=3",
      "method": "GET",
      "timeout": 0,
      "headers": {
        "Accept": "application/vnd.api+json",
        "Content-Type": "application/vnd.api+json"
      },
    };
    
    $.ajax(settings).done(function (response) {
      var data = response.data;
      var d2 = new Date();
      var html = '';
      html += '<table class="table">';
         html += '<tbody>';
            html += '<tr>';
                html += '<th>DATUM</th>';
                html += '<th>VS</th>';
            html += '</tr>';
          var temp = 1,
              tempB = 1;
          for(let a=0; a<data.length;a++){
            let nextMatch = data[a].attributes;

            var newDate = nextMatch.date.split(' ');
            var newTime = newDate[1].split(':');
  
            var date = newDate[0]+'T'+newDate[1]+'Z';
            var d1 = new Date(date);
                         
            html += '<tr>';
            html += '<td>'+formatDateString(nextMatch.date)+'</td>';
            html += '<td>';
            html += '<div class="team-d-wrp">';
                html += '<div class="team-one">';
                    html += '<span class="team-logo">';
                      if(nextMatch.homeClub.shortName == 'FCZ'){
                        html += '<svg xmlns="http://www.w3.org/2000/svg" width="13.95" height="12.877" viewBox="0 0 13.95 12.877">';
                        html += '<path id="Icon_ionic-md-home" data-name="Icon ionic-md-home" d="M8.74,17.377V13.085H11.96v4.292h3.273V10.938h2.093L10.35,4.5,3.375,10.938H5.468v6.438Z" transform="translate(-3.375 -4.5)" fill="#003da5"></path>';
                        html += '</svg>';
                      }else{
                        html += '<svg xmlns="http://www.w3.org/2000/svg" width="13.949" height="13.949" viewBox="0 0 13.949 13.949">';
                        html += '<path id="Icon_awesome-bus" data-name="Icon awesome-bus" d="M13.3,3.487h-.218V2.18c0-1.221-2.7-2.18-6.1-2.18S.872.959.872,2.18V3.487H.654A.654.654,0,0,0,0,4.141v2.18a.654.654,0,0,0,.654.654H.872v4.359a.872.872,0,0,0,.872.872v.872a.872.872,0,0,0,.872.872h.872a.872.872,0,0,0,.872-.872v-.872H9.59v.872a.872.872,0,0,0,.872.872h.872a.872.872,0,0,0,.872-.872v-.872h.174a.688.688,0,0,0,.7-.7V6.975H13.3a.654.654,0,0,0,.654-.654V4.141A.654.654,0,0,0,13.3,3.487ZM3.051,10.9a.872.872,0,1,1,.872-.872A.872.872,0,0,1,3.051,10.9Zm.436-3.051a.872.872,0,0,1-.872-.872V3.487a.872.872,0,0,1,.872-.872h6.975a.872.872,0,0,1,.872.872V6.975a.872.872,0,0,1-.872.872ZM10.9,10.9a.872.872,0,1,1,.872-.872A.872.872,0,0,1,10.9,10.9Z" fill="#ae9357"></path>';
                        html += '</svg>';
                      }
                    html += '</span>';
                    if(nextMatch.homeClub.shortName == 'FCZ'){
                       html += nextMatch.guestClub.name;
                      // html += '<img src="'+nextMatch.guestClub.logo+'" alt="" width="25">';
                    }else{
                      html += nextMatch.homeClub.name;
                      // html += '<img src="'+nextMatch.homeClub.logo+'" alt="" width="25">';
                    }
                html += '</div>';
            html += '</div>';
            html += '</td>';
            html += '</tr>';
             
            
          }
        html += '</tbody>';
      html += '</table>';
      $('.women-team.next-match-wrapper .match-details-wrapper').html(html);
    });
  }
});*/

function youtube_parser(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
}

function furen_score_sort( a, b ) {
  if ( a.rowData.totalScore < b.rowData.totalScore ){
    return 1;
  }
  if ( a.rowData.totalScore > b.rowData.totalScore ){
    return -1;
  }
  return 0;
}

function getFormData($form){
    var unindexed_array = $form.serializeArray();
    var indexed_array = {};

    $.map(unindexed_array, function(n, i){
        indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
}

function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) )
  {
    return 'iOS';

  }
  else if( userAgent.match( /Android/i ) )
  {

    return 'Android';
  }
  else
  {
    return 'unknown'; 
  }
}

$( window ).resize( function() {
  if ( window.matchMedia( '(max-width:767px)' ).matches ) {  
    if( $('.fcz-app-sticky').hasClass('active') === true ) 
    {
       $('body').addClass('fcz-app-active');
    }
  }
  else {
      $('body').removeClass('fcz-app-active');   
    }
});
$( window ).resize();
$( document ).ready(function() {
    var currnt_browser = getMobileOperatingSystem();
    if(currnt_browser == 'iOS'){
      // console.log(currnt_browser);
      $(".fcz-app-sticky .app-link").attr('href','https://apps.apple.com/ch/app/fcz-app/id1642278744');
    }
    
    $(".fcz-app-close").click(function () {
        $(".fcz-app-sticky").remove();
    		// $(".fcz-app-sticky").css("display", "none");
	});
    $(".fcz-app-close").click(function () {
    		$("body").removeClass("fcz-app-active");
	});
});


// version-two home new-arrivals-slider Js

var rev = $('.new-arrivals-slider');
rev.on('init', function(event, slick, currentSlide) {
  var
    cur = $(slick.$slides[slick.currentSlide]),
    next = cur.next(),
    next2 = cur.next().next(),
    prev = cur.prev(),
    prev2 = cur.prev().prev();
  prev.addClass('slick-sprev');
  next.addClass('slick-snext');  
  prev2.addClass('slick-sprev2');
  next2.addClass('slick-snext2');  
  cur.removeClass('slick-snext').removeClass('slick-sprev').removeClass('slick-snext2').removeClass('slick-sprev2');
  slick.$prev = prev;
  slick.$next = next;
}).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  // console.log('beforeChange');
  var
    cur = $(slick.$slides[nextSlide]);
  // console.log(slick.$prev, slick.$next);
  slick.$prev.removeClass('slick-sprev');
  slick.$next.removeClass('slick-snext');
  slick.$prev.prev().removeClass('slick-sprev2');
  slick.$next.next().removeClass('slick-snext2');
  next = cur.next(),  
  prev = cur.prev();
  //prev2.prev().prev();
  //next2.next().next();
  prev.addClass('slick-sprev');
  next.addClass('slick-snext');
  prev.prev().addClass('slick-sprev2');
  next.next().addClass('slick-snext2');
  slick.$prev = prev;
  slick.$next = next;
  cur.removeClass('slick-next').removeClass('slick-sprev').removeClass('slick-next2').removeClass('slick-sprev2');
});

rev.slick({
  speed: 700,
  arrows: true,
  dots: false,
  focusOnSelect: false,
  prevArrow: '<button> prev</button>',
  nextArrow: '<button> next</button>',
  infinite: false,
  centerMode: true,
  slidesPerRow: 1,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerPadding: '0',
   autoplay: false,
  swipe: true,
  customPaging: function(slider, i) {
    return '';
  },
  
});

// version-two home new-arrivals-slider Js End

jQuery(document).ready(function () {
    // jQuery('.next-match-wrapper .match-wrapper-inner').each(function () {

    //     // Cache the highest
    //     var highestBox = 0;

    //     // Select and loop the elements you want to equalise
    //     jQuery('.team-name', this).each(function () {

    //         // If this box is higher than the cached highest then store it
    //         if (jQuery(this).height() > highestBox) {
    //             highestBox = jQuery(this).height();
    //         }
    //     });

    //     // Set the height of all those children to whichever was highest
    //     jQuery('.team-name', this).height(highestBox);
    // });

  
});

$(document).ready(function(){
  $(".onlineshop .megamenu_left.multi-level-menu .list-menu li .header__menu-item").mouseenter(function(){
    $('body').addClass("megamenu-open");
  });
  $(".onlineshop .megamenu_left.multi-level-menu .list-menu li .header__menu-item").mouseleave(function(){
    $('body').removeClass("megamenu-open");
  });

  jQuery.getJSON('/cart.js', function(cart) {
    // console.log('cart',JSON.stringify(cart));
    var cart_items = cart.items;
    if(cart_items.length > 0){
      for(var a=0; a<cart_items.length;a++){
        let product_id = cart_items[a].product_id;
        $('.product-grid .grid__item[data-id="'+product_id+'"]').addClass('product-in-cart');
      }
    }
  });
});


$(document).on('click','.boost-pfs-filter-option-title',function(){
   var categoryTitle = $(this).find('.boost-pfs-filter-option-title-text').text().replace(/[0-9]/g, '');
   $(".filter-toggle-label").remove();
   $("<div class='filter-toggle-label'>"+categoryTitle+"</div>").insertBefore(".boost-pfs-filter-option-content-inner");
});

$(window).on("load", function () {
  var input = $(".boost-pfs-filter-show-result").text();
  if(input != ''){
    var fields = input.split('(');
    var number = fields[1];
    number = number.replace(/[_\W]+/g , '');
    $("<div class='filter-display-number'>"+number+"</div>").insertBefore("span.boost-pfs-filter-tree-mobile-button-label");
  }
});

$(document).on('click','.boost-pfs-filter-close',function(){
  var input = $(".boost-pfs-filter-show-result").text();
  var fields = input.split('(');
  var number = fields[1];
  number = number.replace(/[_\W]+/g , '');
  $('.filter-display-number').text(number);
});

if(typeof activeShop != 'undefined' && activeShop == 'shop_active'){
  var mobileShopSearch = document.querySelector('.aico-mobile-search');
  if(mobileShopSearch != null){
  mobileShopSearch.addEventListener('click', function() {
  var suggestionPanel = document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel');
  if (suggestionPanel) {suggestionPanel.remove();}
  });
  }
}
if(typeof activeShop != 'undefined' && activeShop == 'website_active'){
  var mobileWebSearch = document.querySelector('#cart-icon-search');
  if(mobileWebSearch != null){
  mobileWebSearch.addEventListener('click', function() {
  var searchModalElement = document.querySelector('#search_modal');
  if (searchModalElement) {searchModalElement.style.display = 'block';}
  });
  }
}

$(document).ready(function () {
  $(document).on(
    "click",
    ".page-danke-fur-deine-treue-zum-verein .landing_page_hero_banner .banner__buttons .button.button--secondary",
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      let usersFirstTime = parseInt(getCookie("times_gb_triggered"));
      // console.log("usersFirstTime ⌚", usersFirstTime);

      // remove old message
      $(this).parent().siblings(".error-message").remove();

      if (isNaN(usersFirstTime)) {
        if (
          typeof gb_trigger != "undefined" &&
          typeof gb_trigger == "function"
        ) {
          // console.log("gb_triggers 💥");
          gb_trigger(2836,true,false);
        } else {
          console.warn("gb_trigger is not defined!");
        }
      } else {
        $(this).parent().after(`<p class="error-message">Die Teilnahme ist nur 1x innerhalb von 24h möglich.</p>`)
      }
      createCookie(
        "times_gb_triggered",
        usersFirstTime ? usersFirstTime + 1 : 1,
        1
      );
    }
  );
});

// Move familiensektor element
$(document).ready(function () {
  function moveElement() {
    let $elementToMove = $(
      ".tickets-familiensektor .familiensektor-img-with-content-section .image-with-text__media-item"
    );
    let $targetElement = $(
      ".tickets-familiensektor .familiensektor-img-with-content-section .image-with-text__grid .image-with-text__text ul"
    );

    $elementToMove.insertBefore($targetElement);
  }
  function moveBackElement() {
    let $elementToMoveBack = $(
      ".tickets-familiensektor .familiensektor-img-with-content-section .image-with-text__media-item"
    );
    let $targetElementBack = $(
      ".tickets-familiensektor .familiensektor-img-with-content-section .image-with-text__text-item"
    );

    $elementToMoveBack.insertBefore($targetElementBack);
  }

  function handleMoveOnResize() {
    if ($(window).width() <= 992) {
      moveElement();
    } else {
      moveBackElement();
    }
  }

  handleMoveOnResize();

  $(window).resize(function () {
    handleMoveOnResize();
  });
});
// End Move familiensektor element

